import { PlacardIcon } from '@bfe/moly-icons';
// import { shortenAddress, sleep } from '@web3/base-utils';
import Marquee from '@/components/Marqueen'; //'react-marquee-slider'; //
import { useFm } from '@web3/base-hooks';
// import { winners } from './winnerData';

import styles from './style.module.scss';
import { getWalletLatest } from '@/services/home';
import { useEffect, useState } from 'react';

export default function Winner() {
  const fm = useFm();
  const [data, setData] = useState([]);

  const queryData = async () => {
    const res = await getWalletLatest();
    if (res.success) {
      setData(res.result);
      setTimeout(() => queryData, 5000);
    }
  };
  useEffect(() => {
    queryData();
    setInterval(
      () => {
        queryData();
      },
      10 * 60 * 1000
    );
  }, []);

  if (!data.length) return null;

  return (
    <section className={styles['setion-winner']}>
      <div className="main h-full px-5 flex gap-3 flex-row items-center overflow-hidden">
        <div className="w-6 h-6">
          <PlacardIcon
            className="text-main"
            style={{
              width: 24,
              height: 24,
              display: 'inline-block',
            }}
          />
        </div>
        <div className="flex-1 h-full bm:h-9 gap-10 flex items-center">
          <Marquee
            // autoFill={true}
            pauseOnHover={true}
          >
            {data.map((item, index) => (
              <div className="flex ml-6" key={index}>
                {fm('getScorePlaceholder', {
                  address: item.address, //shortenAddress(item.walletAddress, 6, 4),
                  num: item.point,
                })}
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
